export const salesQueryKeys = {
  all: ["sales"],
  byDate: (date: string) => [...salesQueryKeys.all, date],
} as const;
